<template>
  <div class="item" :class="{ failed: error }">
    <label v-if="label" :for="id" class="form-control-label">
      {{ label }}
      <span v-if="required">*</span>
    </label>
    <textarea
      :id="id"
      :placeholder="`${placeholder}${!label && required ? '*' : ''}`"
      v-bind="$attrs"
      class="form-control"
      :class="{ failed: error }"
      :value="value"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
  </div>
</template>
<script>
import { computed } from 'vue';

export default {
  name: 'TextField',
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    modelValue: String
  },
  emits: ['update:modelValue'],
  setup(props) {
    const required = computed(() => {
      return props.rules.includes('required');
    });

    const value = computed(() => {
      if (!props.modelValue) {
        return null;
      }

      return props.modelValue.replace(/\n/g, ' ');
    });

    return {
      required,
      value
    };
  }
};
</script>
